var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grid-cell"},[_c('a',{attrs:{"href":_vm.previewProject,"target":"_parent _blank"}},[_vm._v(_vm._s(_vm.data.projectId))])])
}
var staticRenderFns = []

export { render, staticRenderFns }